import styled from "styled-components"

export const RemoteTileMiniRoot = styled.div`
    width: 100%;
    height: 100%;
`
